import { Stack, Typography } from "@mui/material";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";
import useResponsive from "src/hooks/useResponsive";

import Context from "../../context";
import BackBtn from "../BackBtn";
import CrossExitBtn from "../InfoStep/components/CrossExitBtn/CrossExitBtn";

// ----------------------------------------------------------------------

export const EntitiesStepHeader = () => {
	const { actions, theme, isFrame } = useContext(Context);

	const isMobile = useResponsive("down", "sm");

	const { translate } = useLocales();

	const onBack = () => {
		actions.onSelectEntity({
			id: "",
			name: ""
		});
		actions.setStep(0);
	};

	return (
		<Stack flexDirection={"row"} alignItems={"center"}>
			<BackBtn onClick={onBack} />
			{!isFrame && theme?.showExit && <CrossExitBtn />}
			<Typography
				variant='h6'
				fontSize={isMobile ? 16 : 24}
				alignSelf={{ xs: "center", sm: "flex-start" }}
				sx={{ ml: 2, mt: 0.6 }}
				color={theme?.colors.primaryText}
			>
				{translate("customization.select_entity")}
			</Typography>
		</Stack>
	);
};

export default EntitiesStepHeader;
